import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { format } from 'date-fns';

const CurrentLeavesCard = ({ currentLeaves }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Staff Currently On Leave</CardTitle>
      </CardHeader>
      <CardContent>
        {!currentLeaves || currentLeaves.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No staff on leave currently</p>
        ) : (
          <div className="space-y-2 max-h-[320px] overflow-y-auto pr-1">
            {currentLeaves.map((leave) => (
              <div key={leave.id} className="flex items-center justify-between p-3 bg-blue-50 rounded-lg border border-blue-200">
                <div>
                  <p className="font-medium">{leave.employee_name}</p>
                  <p className="text-sm text-gray-600 capitalize">{leave.leave_type} leave</p>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-600">
                    {format(new Date(leave.start_date), 'MMM dd')} - {format(new Date(leave.end_date), 'MMM dd')}
                  </p>
                  <Badge variant="secondary">{leave.days} days</Badge>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

const UpcomingLeavesTable = ({ upcomingLeaves }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Upcoming Leaves <span className="text-sm font-normal text-gray-500">(Next 30 Days)</span></CardTitle>
      </CardHeader>
      <CardContent>
        {!upcomingLeaves || upcomingLeaves.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No upcoming leaves</p>
        ) : (
          <div className="space-y-2 max-h-[320px] overflow-y-auto pr-1" data-testid="upcoming-leaves-list">
            {upcomingLeaves.map((leave) => (
              <div key={leave.id} className="flex items-center justify-between gap-2 p-3 bg-violet-50 rounded-lg border border-violet-200" data-testid={`upcoming-leave-${leave.id}`}>
                <div className="min-w-0">
                  <p className="font-medium truncate">{leave.employee_name}</p>
                  <p className="text-sm text-gray-600 capitalize">{leave.leave_type} leave</p>
                </div>
                <div className="text-right shrink-0">
                  <p className="text-sm text-gray-600">
                    {format(new Date(leave.start_date), 'MMM dd')} - {format(new Date(leave.end_date), 'MMM dd, yyyy')}
                  </p>
                  <Badge variant="secondary">{leave.days} days</Badge>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export { CurrentLeavesCard, UpcomingLeavesTable };
